import { Tldraw } from 'tldraw'
import 'tldraw/tldraw.css'
import { AIToolbar } from './components/AIToolbar'
import { useAIImageGeneration } from './hooks/useAIImageGeneration'

export default function App() {
  const { generateImage, isGenerating } = useAIImageGeneration()

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column' }}>
      {/* AI工具栏 */}
      <AIToolbar onGenerate={generateImage} isGenerating={isGenerating} />
      
      {/* 无限画布 */}
      <div style={{ flex: 1, position: 'relative' }}>
        <Tldraw
          onMount={(editor) => {
            // 将editor实例暴露给外部
            window.tldrawEditor = editor
          }}
        />
      </div>
    </div>
  )
}
